import jwtDecode from "jwt-decode"
import { isEmpty } from "lodash"
import { User } from "../store/serializers/users"
import userModel from "../store/models/user"

export const authenticationReducerDefaultState = {
  authenticatedUser: {},
  refreshedUser: false,
  loggingIn: false,
  loginError: false,
  registering: false,
  registerError: false,
  token: "",
  loginDialogOpen: false,
  isSuperAdmin: false,
}

let newState

export default (state = authenticationReducerDefaultState, action) => {
  switch (action.type) {
    case "LOGGING_IN":
      return {
        ...state,
        loggingIn: action.loggingIn,
        refreshedUser: true,
      }
    case "LOGIN_ERROR":
      return {
        ...state,
        loginError: action.error,
      }
    case "LOGIN_SUCCESS":
      newState = {
        ...state,
        authenticatedUser: !isEmpty(action.user)
          ? action.user
          : state.authenticatedUser,
      }
      if (action.token) {
        const decodedToken = jwtDecode(action.token)
        newState.token = action.token
        if (decodedToken.companies === "*") {
          newState.isSuperAdmin = true
        }
      }
      return newState
    case "REGISTERING":
      return {
        ...state,
        registering: action.registering,
        refreshedUser: true,
      }
    case "REGISTER_ERROR":
      return {
        ...state,
        registerError: action.error,
      }
    case "REGISTER_SUCCESS":
      newState = {
        ...state,
        authenticatedUser: action.user,
      }
      if (action.token) {
        const decodedToken = jwtDecode(action.token)
        newState.token = action.token
        if (decodedToken.companies === "*") {
          newState.isSuperAdmin = true
        }
      }
      return newState
    case "UPDATE_LOGGED_IN_USER":
      return {
        ...state,
        authenticatedUser:
          action.updates.id === state.authenticatedUser.id
            ? new User(userModel, {
                ...state.authenticatedUser,
                ...action.updates,
              })
            : state.authenticatedUser,
      }
    case "SET_USER":
      return {
        ...state,
        authenticatedUser: action.user,
      }
    // LOGOUT LOGIC THAT'S BUGGED AND NOT STAYING CLEARED ON REFRESH SOMETIMES
    case "LOGOUT":
      localStorage.clear()
      return {
        ...state,
        authenticatedUser: {},
        token: "",
      }
    case "TOGGLE_LOGIN_DIALOG":
      return {
        ...state,
        loginDialogOpen: action.loginDialogOpen,
      }
    case "USER::SET_REFRESHED_USER":
      return {
        ...state,
        refreshedUser: true,
      }
    case "USER::UPDATE_USER_COMPANY":
      return {
        ...state,
        authenticatedUser: {
          ...state.authenticatedUser,
          companies: state.authenticatedUser.companies.map(company => {
            if (company.id === action.updates.id) {
              company = {
                ...company,
                ...action.updates,
              }
            }
            return company
          }),
        },
      }
    default:
      return state
  }
}
